import React, { Fragment } from "react";
import HomeComponent from "../component/app/home/Home.component";
import { useAuth } from "../context/Auth.context";
import DealershipComponent from "../component/app/admin/dealership/Dealership.component";
import TransactionsComponent from "../component/app/admin/transactionHistory/Transactions.component";
import CreateDealershipComponent from "../component/app/admin/dealership/CreateDealership.component";

const CreateDealershipPage = () => {
  const auth = useAuth();

  return (
    <Fragment>
     <CreateDealershipComponent/>
    </Fragment>
  );
};

export default CreateDealershipPage;
